<template>
  <div
    v-show="fabbable"
    class="fab"
  >
    <div
      class="fab-button"
      :class="{'tapped': showFab, 'checkmark': checkmark}"
      @click="addEvent ? addEventButton() : toggleFab()"
    >
      <div
        v-show="!checkmark && !showFab"
        class="plus"
      >
        <div></div>
        <div></div>
      </div>
      <div
        v-show="!checkmark && showFab"
        class="plus"
      >
        <div></div>
        <div></div>
      </div>
      <div
        v-show="checkmark && !showFab"
        class="check"
      >
        <div></div>
        <div></div>
      </div>
      <div
        v-show="checkmark && showFab"
        class="plus close"
      >
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      v-if="addPayment"
      class="fab-actions"
      :class="showFab ? 'tapped' : ''"
    >
      <div class="fab-container">
        <h5>{{ $lang.messages.recurringPayments }}</h5>
        <span>
          <router-link :to="{ name: 'ScheduleRecurringPaymentSpousalMaintenance', query:{ type: 'recurring' } }" class="link">
            <div @click="toggleFab">
              {{ $lang.messages.spousalMaintenance }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
        <span @click.capture="preventClick">
          <router-link :to="{ name: 'ScheduleRecurringPaymentChildMaintenance', query:{ type: 'recurring' } }" class="link">
            <div :class="{'disabled-link' : !hasChildren}" @click="toggleFab">
              {{ $lang.messages.childMaintenance }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
        <span @click.capture="preventClick">
          <router-link :to="{ name: 'ScheduleRecurringPaymentSharedExpenses', query:{ type: 'recurring' } }" class="link">
            <div :class="{'disabled-link' : !hasChildren}" @click="toggleFab">
              {{ $lang.messages.sharedExpense }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
      </div>
      <div class="fab-container">
        <h5>{{ $lang.messages.oneTimePayments }}</h5>
        <span>
          <router-link :to="{ name: 'AddPaymentSpousalMaintenance', query: { type: 'onetime' } }" class="link">
            <div @click="toggleFab">
              {{ $lang.messages.spousalMaintenance }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
        <span @click.capture="preventClick">
          <router-link :to="{ name: 'AddPaymentChildMaintenance', query: { type: 'onetime' } }" class="link">
            <div :class="{'disabled-link' : !hasChildren}" @click="toggleFab">
              {{ $lang.messages.childMaintenance }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
        <span @click.capture="preventClick">
          <router-link :to="{ name: 'AddPaymentSharedExpenses', query: { type: 'onetime' } }" class="link">
            <div :class="{'disabled-link' : !hasChildren}" @click="toggleFab">
              {{ $lang.messages.sharedExpense }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
      </span>
      </div>
    </div>
    <div
      v-if="calendar"
      class="fab-actions"
      :class="{'tapped': showFab, 'calendar': calendar}"
    >
      <div class="fab-container">
        <span>
          <router-link :to="{ name: 'AddEvent' }" class="link">
            <div @click="toggleFab">
              {{ $lang.messages.addEvent }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
      </div>
      <div class="fab-container">
        <span>
          <router-link :to="{ name: 'ScheduleChildVisitation' }" class="link">
            <div @click="toggleFab">
              {{ $lang.messages.scheduleChildVisitation }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </router-link>
        </span>
      </div>
    </div>
    <div
        v-if="payable"
        class="fab-actions"
        :class="{'tapped': showFab, 'payable': payable}"
    >
      <div class="fab-container">
        <span>
          <div class="link">
            <div @click="alreadyPaid">
              {{ $lang.messages.alreadyPaid }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </div>
        </span>
      </div>
      <div class="fab-container">
        <span>
          <div class="link">
            <div @click="payNow">
              {{ $lang.messages.addPayment }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </div>
        </span>
      </div>
      <div class="fab-container" :class="{'disabled': payDisabled}">
        <span>
          <div class="link">
            <div @click="payingNow">
              {{ $lang.messages.payNow }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </div>
        </span>
      </div>
    </div>
    <div
      v-if="schedule"
      class="fab-actions"
      :class="{'tapped': showFab, 'schedule': schedule}"
    >
      <div class="fab-container" :class="{'disabled': scheduleDisabled}">
        <span>
          <div class="link">
            <div @click="schedulePayment">
              {{ $lang.messages.scheduleExpense }}
              <img src="@/assets/images/arrow_right.png" />
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FPFab",
    props: {
      fabbableParent: {
        type: Boolean,
        required: true,
        default: () => {
          return false;
        }
      }
    },
    data() {
      return {
        showFab: false,
        hasChildren: this.$store.getters.hasChildren,
        route: this.$router.currentRoute.path,
        addPayment: false,
        checkmark: false,
        calendar: false,
        payable: false,
        edit: !!this.$router.currentRoute.params.id,
        payDisabled: false,
        scheduleDisabled: false,
        schedule: false,
        fabbable: false,
        eventFab: false,
        addEvent: false,
      }
    },
    watch: {
      $route: function(to, from) {
        if (to.params.id) {
          this.edit = true;
        }
        this.route = to.path;
        this.currentPath();
      },
      fabbableParent: function (val) {
        this.showFab = !val;
        if (val) {
            this.eventFab = !val;
        }
      }
    },
    mounted() {
      this.$root.$on('pay-disabled', value => {
        this.payDisabled = value.prop;
      });
      this.$root.$on('schedule-disabled', value => {
        this.scheduleDisabled = value
      })
      this.currentPath();
    },
    methods: {
      toggleFab() {
        this.eventFab = !this.eventFab;
        this.$emit('toggle-fab', !this.eventFab)
      },
      alreadyPaid() {
          this.$root.$emit('already-paid');
          this.toggleFab();
      },
      payNow() {
        this.$root.$emit('submit-payment');
        this.toggleFab();
      },
      addEventButton() {
        this.$root.$emit('add-event');
      },
      schedulePayment() {
        this.$root.$emit('schedule-payment');
        this.toggleFab();
      },
      payingNow() {
        if (!this.payDisabled) {
          this.$root.$emit('paying-now');
          this.toggleFab();
        }
      },
      preventClick(e) {
        if (!this.hasChildren) {
          e.preventDefault()
        }
      },
      updateProps() {
        this.hasChildren = this.$store.getters.hasChildren
      },
      currentPath() {
        switch (this.route) {
          case '/payments/unpaid':
          case '/payments/recurring':
          case '/dashboard/':
          case '/payments/history':
            this.addPayment = true;
            this.fabbable = true;
            this.checkmark = false;
            this.calendar = false;
            this.payable = false;
            this.schedule = false;
            this.addEvent = false;
            return;
          case '/calendar':
            this.addPayment = false;
            this.fabbable = true;
            this.checkmark = false;
            this.calendar = true;
            this.payable = false;
            this.schedule = false;
            this.addEvent = false;
            return;
          default:
            if (this.route.indexOf('details') !== -1) {
              this.addPayment = true;
              this.fabbable = true;
              this.checkmark = false;
              this.calendar = false;
              this.payable = false;
              this.schedule = false;
              this.addEvent = false;
            }
            else if (this.route.indexOf('unpaid/alimony') !== -1 || this.route.indexOf('unpaid/child-support') !== -1 || this.route.indexOf('unpaid/shared-expenses') !== -1) {
              this.addPayment = false;
              this.fabbable = true;
              this.checkmark = true;
              this.calendar = false;
              this.payable = true;
              this.schedule = false;
              this.addEvent = false;
            }
            else if (this.route.indexOf('recurring/alimony') !== -1 || this.route.indexOf('recurring/child-support') !== -1 || this.route.indexOf('recurring/shared-expenses') !== -1) {
              this.addPayment = false;
              this.fabbable = true;
              this.checkmark = true;
              this.calendar = false;
              this.payable = false;
              this.schedule = true;
              this.addEvent = false;
            }
            else if(this.route.indexOf('add-event') !== -1) {
              this.addPayment = false;
              this.fabbable = true;
              this.checkmark = true;
              this.calendar = false;
              this.payable = false;
              this.schedule = false;
              this.addEvent = true;
            }
            else {
              this.addPayment = false;
              this.fabbable = false;
              this.checkmark = false;
              this.payable = false;
              this.schedule = false;
              this.addEvent = false;
            }
            return;
        }
      }
    }
  }
</script>
